import React, { forwardRef } from 'react';
import cn from 'classnames';
import BaseButton from './BaseButton';

const EditButton = forwardRef(({ title = 'Edit', className, ...props }, ref) => {
  const btnClassName = cn('edit-button', { [className]: className });
  return (
    <BaseButton
      ref={ref}
      id='edit-button'
      type='button'
      className={btnClassName}
      icon='edit'
      tooltip={title}
      themeColor='secondary'
      {...props}
    />
  );
});

export default EditButton;
